import React from "react";
import PanelLayout from "../components/PanelLayout";
import "./styles/PanelEditAd.css";
import "./styles/PanelEditMarketStore.css";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import * as actions from "../redux/actions/marketstoreActions";
import { FaSave, FaArrowLeft } from "react-icons/fa";
import { Translate, I18n } from "react-redux-i18n";
import alertify from "alertifyjs";
import "../components/styles/Alertify.css";
import "../components/styles/AlertifyTheme.css";
import "../components/styles/Alertify.min.css";
import "../components/styles/AlertifyTheme.min.css";
import { ListSkeleton } from "../components/Skeleton";
import MiniLoader from "../components/MiniLoader";

function mapMarketstoreToForm(marketstore) {
  if (!marketstore || !marketstore.Id) {
    return null;
  }

  return {
    name: marketstore.Name || "",
    text_color: marketstore.TextColor || "#ffffff",
    description: marketstore.Description || "",
    backgroundColor: marketstore.BackGroundColor || "#ffffff",
    link_facebook: marketstore.LinkFacebook || "",
    link_twitter: marketstore.LinkTwitter || "",
    email: marketstore.Email || "",
    phone: marketstore.Phone || "",
    home: marketstore.Home || "",
    address: marketstore.Address || "",
    city: marketstore.City || "",
    state: marketstore.State || "",
  };
}

function FieldRow({ label, children, onSave, saving, disabled }) {
  return (
    <div className="panel-ms-edit-field">
      <label className="panel-edit-ad-label">{label}</label>
      <div className="panel-ms-edit-field__row">
        <div className="panel-ms-edit-field__input">{children}</div>
        <button
          type="button"
          className="panel-ms-edit-field__save"
          onClick={onSave}
          disabled={disabled || saving}
          aria-label="Save"
        >
          <FaSave />
        </button>
      </div>
    </div>
  );
}

class PanelEditMarketStore extends React.Component {
  state = {
    form: {
      name: "",
      text_color: "#ffffff",
      description: "",
      backgroundColor: "#ffffff",
      link_facebook: "",
      link_twitter: "",
      email: "",
      phone: "",
      home: "",
      address: "",
      city: "",
      state: "",
    },
    formReady: false,
    savingField: null,
  };

  componentDidMount() {
    this.loadStore();
  }

  componentDidUpdate(prevProps) {
    const prevId = prevProps.marketstore?.Id;
    const nextId = this.props.marketstore?.Id;

    if (!this.state.formReady && nextId && prevId !== nextId) {
      this.initForm(this.props.marketstore);
    }
  }

  loadStore = async () => {
    try {
      await this.props
        .LoadMyMarketStore(this.props.token, {
          id: this.props.user_id,
          lang: I18n.t("locale"),
        })
        .then(() => {
          if (this.props.error) {
            alertify.warning(I18n.t(this.props.error));
          } else if (this.props.marketstore?.Id) {
            this.initForm(this.props.marketstore);
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  initForm = (marketstore) => {
    const form = mapMarketstoreToForm(marketstore);
    if (form) {
      this.setState({ form, formReady: true });
    }
  };

  onChangeForm = (event) => {
    const { name, value } = event.target;
    this.setState({
      form: {
        ...this.state.form,
        [name]: value,
      },
    });
  };

  onClickSaveStore = async (fieldName) => {
    const fieldValue = this.state.form[fieldName];

    this.setState({ savingField: fieldName });

    try {
      await this.props
        .EditMyMarketStore(this.props.token, {
          field_name: fieldName,
          field_value: fieldValue,
          id: this.props.user_id,
        })
        .then(() => {
          if (this.props.error_update) {
            alertify.warning(I18n.t(this.props.error_update));
          } else {
            alertify.success(I18n.t("saved_succesfull"));
          }
        });
    } catch (error) {
      console.log(error);
    } finally {
      this.setState({ savingField: null });
    }
  };

  render() {
    const { loading, loading_update, marketstore } = this.props;
    const { form, savingField } = this.state;
    const hasStore = Boolean(marketstore?.Id);

    return (
      <PanelLayout>
        <div className="panel-ms-edit-page panel-edit-ad-page">
          <header className="panel-edit-ad-page__header">
            <Link
              to="/panel/marketstore"
              className="panel-edit-ad-page__back"
              aria-label="Back"
            >
              <FaArrowLeft />
            </Link>
            <div className="panel-edit-ad-page__heading">
              <h1 className="panel-edit-ad-page__title">
                <Translate value="marketstore_edit" />
              </h1>
              <p className="panel-edit-ad-page__subtitle">
                <Translate value="marketstore_title" />
              </p>
            </div>
          </header>

          {loading ? (
            <div className="panel-ms-edit-page__loading">
              <ListSkeleton />
            </div>
          ) : !hasStore ? (
            <div className="panel-ms-edit-empty">
              <p>
                <Translate value="marketstore_not_list" />
              </p>
              <Link to="/panel/marketstore" className="panel-ms-edit-empty__link">
                <Translate value="marketstore_activate" />
              </Link>
            </div>
          ) : (
            <>
              <section className="panel-edit-ad-card">
                <h2 className="panel-edit-ad-card__title">
                  <Translate value="marketstore_name" />
                </h2>

                <FieldRow
                  label={<Translate value="marketstore_name" />}
                  onSave={() => this.onClickSaveStore("name")}
                  saving={savingField === "name"}
                >
                  <input
                    type="text"
                    className="panel-edit-ad-input"
                    value={form.name}
                    name="name"
                    required
                    onChange={this.onChangeForm}
                  />
                </FieldRow>

                <FieldRow
                  label={<Translate value="marketstore_title_textcolor" />}
                  onSave={() => this.onClickSaveStore("text_color")}
                  saving={savingField === "text_color"}
                >
                  <input
                    name="text_color"
                    type="color"
                    value={form.text_color}
                    onChange={this.onChangeForm}
                    className="panel-edit-ad-input panel-ms-edit-color"
                  />
                </FieldRow>

                <FieldRow
                  label={<Translate value="marketstore_description" />}
                  onSave={() => this.onClickSaveStore("description")}
                  saving={savingField === "description"}
                >
                  <input
                    type="text"
                    className="panel-edit-ad-input"
                    name="description"
                    value={form.description}
                    onChange={this.onChangeForm}
                  />
                </FieldRow>

                <FieldRow
                  label={<Translate value="marketstore_decription_textcolor" />}
                  onSave={() => this.onClickSaveStore("backgroundColor")}
                  saving={savingField === "backgroundColor"}
                >
                  <input
                    name="backgroundColor"
                    type="color"
                    className="panel-edit-ad-input panel-ms-edit-color"
                    value={form.backgroundColor}
                    onChange={this.onChangeForm}
                  />
                </FieldRow>
              </section>

              <section className="panel-edit-ad-card">
                <h2 className="panel-edit-ad-card__title">
                  <Translate value="marketstore_facebook_address" />
                </h2>

                <FieldRow
                  label={<Translate value="marketstore_facebook_address" />}
                  onSave={() => this.onClickSaveStore("link_facebook")}
                  saving={savingField === "link_facebook"}
                >
                  <div className="panel-edit-ad-input-group">
                    <span className="panel-edit-ad-input-group__prefix">
                      https://
                    </span>
                    <input
                      className="panel-edit-ad-input"
                      name="link_facebook"
                      type="text"
                      value={form.link_facebook}
                      onChange={this.onChangeForm}
                    />
                  </div>
                </FieldRow>

                <FieldRow
                  label={<Translate value="marketstore_twitter_address" />}
                  onSave={() => this.onClickSaveStore("link_twitter")}
                  saving={savingField === "link_twitter"}
                >
                  <div className="panel-edit-ad-input-group">
                    <span className="panel-edit-ad-input-group__prefix">
                      https://
                    </span>
                    <input
                      className="panel-edit-ad-input"
                      name="link_twitter"
                      type="text"
                      value={form.link_twitter}
                      onChange={this.onChangeForm}
                    />
                  </div>
                </FieldRow>
              </section>

              <section className="panel-edit-ad-card">
                <h2 className="panel-edit-ad-card__title">
                  <Translate value="marketstore_email" />
                </h2>

                <FieldRow
                  label={<Translate value="marketstore_email" />}
                  onSave={() => this.onClickSaveStore("email")}
                  saving={savingField === "email"}
                >
                  <input
                    type="email"
                    value={form.email}
                    className="panel-edit-ad-input"
                    name="email"
                    onChange={this.onChangeForm}
                  />
                </FieldRow>

                <FieldRow
                  label={<Translate value="marketstore_phone" />}
                  onSave={() => this.onClickSaveStore("phone")}
                  saving={savingField === "phone"}
                >
                  <input
                    type="tel"
                    value={form.phone}
                    className="panel-edit-ad-input"
                    name="phone"
                    onChange={this.onChangeForm}
                  />
                </FieldRow>
              </section>

              <section className="panel-edit-ad-card">
                <h2 className="panel-edit-ad-card__title">
                  <Translate value="marketstore_about_us" />
                </h2>

                <FieldRow
                  label={<Translate value="marketstore_about_us" />}
                  onSave={() => this.onClickSaveStore("home")}
                  saving={savingField === "home"}
                >
                  <textarea
                    name="home"
                    className="panel-edit-ad-input panel-ms-edit-textarea"
                    rows="5"
                    value={form.home}
                    onChange={this.onChangeForm}
                  />
                </FieldRow>

                <FieldRow
                  label={<Translate value="marketstore_address" />}
                  onSave={() => this.onClickSaveStore("address")}
                  saving={savingField === "address"}
                >
                  <textarea
                    name="address"
                    className="panel-edit-ad-input panel-ms-edit-textarea"
                    rows="4"
                    value={form.address}
                    onChange={this.onChangeForm}
                  />
                </FieldRow>

                <FieldRow
                  label={<Translate value="marketstore_city" />}
                  onSave={() => this.onClickSaveStore("city")}
                  saving={savingField === "city"}
                >
                  <input
                    type="text"
                    name="city"
                    className="panel-edit-ad-input"
                    placeholder={I18n.t("marketstore_city")}
                    value={form.city}
                    onChange={this.onChangeForm}
                  />
                </FieldRow>

                <FieldRow
                  label={<Translate value="marketstore_state" />}
                  onSave={() => this.onClickSaveStore("state")}
                  saving={savingField === "state"}
                >
                  <input
                    type="text"
                    name="state"
                    placeholder={I18n.t("marketstore_state")}
                    className="panel-edit-ad-input"
                    value={form.state}
                    onChange={this.onChangeForm}
                  />
                </FieldRow>
              </section>

              {loading_update && (
                <div className="panel-ms-edit-page__loading">
                  <MiniLoader />
                </div>
              )}

              <footer className="panel-ms-edit-page__footer">
                <Link to="/panel/marketstore" className="panel-ms-edit-page__back-link">
                  <FaArrowLeft />
                  <Translate value="back" />
                </Link>
              </footer>
            </>
          )}
        </div>
      </PanelLayout>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,
    marketstore: reducer.marketstore.item,
    loading: reducer.marketstore.loading,
    error: reducer.marketstore.error,
    error_update: reducer.marketstore.error_update,
    loading_update: reducer.marketstore.loading_update,
  };
}

const mapDispatchToProps = (dispatch) => ({
  LoadMyMarketStore: (token, params) =>
    dispatch(actions.loadItemMe({ token, params })),
  EditMyMarketStore: (token, params) =>
    dispatch(actions.editMyMarketStore({ token, params })),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PanelEditMarketStore);
